<div class="ac-host">
  <label *ngIf="rotulo" class="ac-rotulo" [attr.for]="'ac-' + (rotulo || 'campo')">{{ rotulo }}</label>

  <div class="ac-campo">
    <nb-form-field fullWidth>
      <nb-icon nbPrefix icon="search-outline"></nb-icon>
      <input
        [id]="'ac-' + (rotulo || 'campo')"
        nbInput
        fullWidth
        type="text"
        autocomplete="off"
        role="combobox"
        [attr.aria-expanded]="aberto"
        [attr.aria-invalid]="opcaoInvalida"
        [placeholder]="placeholder"
        [disabled]="desabilitado"
        [attr.title]="texto || null"
        [(ngModel)]="texto"
        (focus)="aoFocar()"
        (input)="aoDigitar()"
        (blur)="aoSair()"
      />
    </nb-form-field>

    <!-- O input corta o rótulo longo e não quebra linha. Escolhido o registro, o nome
         inteiro aparece aqui embaixo, fora do fluxo para não mudar a altura do campo. -->
    <p class="ac-selecionado" *ngIf="!aberto && rotuloSelecionado">{{ rotuloSelecionado }}</p>

    <ul class="ac-painel" *ngIf="aberto" role="listbox">
      <li *ngIf="carregando" class="ac-opcao ac-opcao--inerte">
        <nb-spinner status="primary" size="tiny"></nb-spinner>
        Carregando…
      </li>

      <li
        *ngIf="!carregando && permiteTodos"
        class="ac-opcao ac-opcao--todas"
        role="option"
        [attr.aria-selected]="!selecionadoId"
        (mousedown)="$event.preventDefault(); selecionar(null)"
      >
        {{ rotuloTodos }}
      </li>

      <li
        *ngFor="let o of filtradas; trackBy: trackById"
        class="ac-opcao"
        role="option"
        [attr.aria-selected]="o.id === selecionadoId"
        [class.ac-opcao--selecionada]="o.id === selecionadoId"
        (mousedown)="$event.preventDefault(); selecionar(o)"
      >
        {{ o.rotulo }}
      </li>

      <li *ngIf="!carregando && !filtradas.length" class="ac-opcao ac-opcao--inerte">
        {{ msgSemResultado }}
      </li>
    </ul>
  </div>

  <!-- FRM-03: texto que não casa não vira valor, e o campo diz por quê. -->
  <p class="ac-erro" *ngIf="opcaoInvalida">
    Escolha uma opção da lista. O que foi digitado não corresponde a nenhuma.
  </p>
</div>
